module.exports = __webpack_public_path__ + "cf134459a27d2d89b2760abf87aabfd5.svg";